module.exports = __webpack_public_path__ + "static/img/smartProduct5.873bfa51.png";